<div #mainDiv_ll_loanmgmt_bbc>
  <div *ngIf="bundle.showObj" class="scroll-pane"
       [style.width.px]="bundle.editorW"
       [style.height.px]="bundle.editorH">
    <div class="content-wrapper" [style.width.px]="bundle.editorW - 30">
      <div *ngIf="bundle.errorMessage" class="error-message">
        {{ bundle.errorMessage }}
      </div>
      <iframe *ngIf="!bundle.errorMessage"
              [src]="bundle.REPORT_BODY | safe: 'resourceUrl'"
              [style.width.px]="bundle.editorW - 30"
              [style.height.px]="bundle.editorH - 20"
              (error)="onIframeError($event)">
      </iframe>
    </div>
  </div>
</div>
